<template>
  <div class="px-2">
    <EditBlogPostDialog ref="editDialog" :post="post" />
    <div class="h-full flex-nowrap d-flex flex-column">
      <div
        class="flex-grow-0 align-center pb-2 text-subtitle-2 grey--text text--darken-2 d-flex"
      >
        <div>{{ upperFirst(post.info) }}</div>
        <v-spacer></v-spacer>
        <div>
          <v-icon small color="primary">mdi-thumb-up</v-icon>
          {{ post.likes }}
          <v-icon class="mr-1" color="primary" small>mdi-eye</v-icon
          >{{ post.views }}
        </div>
      </div>
      <v-card elevation="5" tile>
        <v-responsive
          :aspect-ratio="3 / 2"
          class="grow w-full h-full"
          :max-height="maxHeight"
          min-height="200"
        >
          <v-img
            cover
            class="w-full h-full object-cover"
            :src="$connection + post.photoURL"
            :alt="post.title"
          >
            <template v-slot:placeholder>
              <v-row
                class="fill-height ma-0 grey lighten-2"
                align="center"
                justify="center"
              >
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-row> </template
          ></v-img>
        </v-responsive>
        <div class="flex-nowrap d-flex flex-column px-3 pb-3">
          <div
            class="grey--text flex-grow-0 text-caption my-2 font-weight-bold"
          >
            {{ $moment(post.created_at).format("DD.MM.YYYY") }}
          </div>
          <div
            class="text-subtitle-1 flex-grow-0 font-weight-medium grey--text text--darken-4 ellipsis-1"
            v-html="post.title"
          ></div>
          <div
            class="text-body-2 flex-grow-1 mt-2 ellipsis-7 overflow-hidden"
            v-html="post.text"
          ></div>
          <div class="flex-grow-0 align-center py-3 d-flex">
            <router-link
              class="text-decoration-none"
              :to="{ name: 'PostDetails', params: { id: post._id } }"
            >
              <v-btn
                v-if="!$route.path.includes('account')"
                @click="$store.dispatch('publicApi/increaseViews', post._id)"
                color="primary"
                class="text-capitalize px-0 ml-n2"
                text
              >
                <v-icon color="grey">mdi-chevron-right</v-icon>
                {{ $t("blog.read_on") }}
              </v-btn>
              <v-btn
                v-else
                color="primary"
                class="text-capitalize px-0 ml-n2"
                text
              >
                <v-icon color="grey">mdi-chevron-right</v-icon>
                {{ $t("blog.read_on") }}
              </v-btn>
            </router-link>
            <v-spacer></v-spacer>
            <div class="d-flex align-center flex-wrap">
              <div
                class="mt-2 d-flex justify-center"
                v-if="$route.path.includes('blog')"
              >
                <!-- <v-spacer></v-spacer> -->
                <v-btn
                  :disabled="!val"
                  fab
                  small
                  text
                  v-for="(val, key, i) in post.social_media"
                  :key="i"
                  class="ml-3"
                  v-show="val"
                  :href="val"
                >
                  <v-icon :color="config.icons.social_media[key].color">{{
                    config.icons.social_media[key].icon
                  }}</v-icon>
                </v-btn>
              </div>
            </div>
          </div>
          <v-divider v-if="!hideDetails"></v-divider>
          <BlogPostInfo
            :post="post"
            v-if="!hideDetails"
            class="flex-grow-1"
            :social_media="post.social_media"
            :author="post.owner"
            :article_count="post.article_number"
          />
        </div>
        <div class="relative">
          <v-tooltip v-if="post.blocked" right>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-show="post.blocked"
                class="absolute top-0 left-0 mt-4 ml-1"
                color="amber"
                v-bind="attrs"
                v-on="on"
                small
                >mdi-block-helper</v-icon
              >
            </template>
            <span v-if="post.blocked_by"
              >{{ $t("blocked_by") }} {{ post.blocked_by.name }}</span
            >
          </v-tooltip>
          <v-speed-dial
            v-model="fab"
            v-if="$route.path.includes('account')"
            right
            class="absolute mt-1 mr-n3"
            direction="left"
            transition="slide-x-reverse-transition"
          >
            <template v-slot:activator>
              <v-btn v-model="fab" text fab small>
                <v-icon color="red darken-1" v-if="fab">mdi-close</v-icon>
                <v-icon v-else color="grey darken-1"
                  >mdi-dots-horizontal</v-icon
                >
              </v-btn>
            </template>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="$refs.editDialog.open()"
                  fab
                  dark
                  small
                  color="green"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("edit_item") }}</span>
            </v-tooltip>

            <v-tooltip
              top
              v-if="
                user.roles.includes('owner') ||
                user.roles.includes('admin') ||
                user.roles.includes('department')
              "
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab
                  @click="$store.dispatch('blogPost/blockPost', post._id)"
                  dark
                  small
                  color="orange"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-block-helper</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("block_item") }}</span>
            </v-tooltip>

            <v-tooltip
              top
              v-if="
                user.roles.includes('owner') || user.roles.includes('admin')
              "
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab
                  @click="
                    $store.dispatch('blogPost/deleteBlogPost', { id: post._id })
                  "
                  dark
                  small
                  color="red"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("delets_item") }}</span>
            </v-tooltip>
          </v-speed-dial>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import BlogPostInfo from "@/components/BlogPostInfo";
import EditBlogPostDialog from "@/components/dialogs/EditBlogPostDialog";
// import SocialMedia from "@/components/SocialMedia";
export default {
  components: {
    EditBlogPostDialog,
    BlogPostInfo,
  },
  computed: {
    postsLiked() {
      return this.$store.getters["publicApi/getPostsLiked"];
    },
    config() {
      return this.$store.getters["config/getConfig"];
    },
    user() {
      return this.$store.getters["user/getUser"];
    },
    blocked() {
      return this.post.blocked;
    },
  },
  methods: {
    upperFirst(word) {
      return word.charAt(0).toUpperCase() + word.substring(1);
    },
  },
  props: {
    maxHeight: { type: String, default: "200" },  
    post: { type: Object },
    hideDetails: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fab: false,
    };
  },
  watch: {
    post: {
      handler(p) {
        this.post = p;
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
</style>